<template>
	<Layout>
		<div class="container box_general" v-if="!loading && item">
			<div class="header_box">
				<div>
					<h2 class="m-0"><i class="icon-medicine"></i>Prescripción #{{ item.code }}</h2>
					<div class="d-flex pb-2">
						<small class="ml-5">Creada: {{ item.createdAt | moment("DD-MM-YYYY HH:mm") }}</small>
						<small class="ml-1" v-if="item.dispensation"> | Dispensada: {{ item.dispensation.createdAt | moment("DD-MM-YYYY HH:mm") }}</small>
					</div>
				</div>
				<h4>
					<span :class="`badge badge-${item.statusClass}`">{{ item.statusText }}</span>
				</h4>
			</div>

			<div class="row">
				<div class="col-md-8">
					<div class="book-data">
						<div class="box">
							<div class="subtitle">MEDICAMENTO</div>
							<div class="value">
								{{ item.product.name }}
							</div>
							<p>{{ item.product.presentation }}</p>
							<p class="mt-2"><strong>Administración: </strong>{{ item.dosage }}</p>
							<p class="mt-2"><strong>Afecciones: </strong>{{ item.affections }}</p>
							<p class="mt-2"><strong>Antecedentes: </strong>{{ item.medicalHistory }}</p>
						</div>

						<div class="box" v-if="item.dispensation">
							<div class="subtitle">DISPENSADO A</div>
							<p>
								{{ item.dispensation.createdAt | moment("") }}
							</p>
						</div>

						<!-- <div class="box" v-if="item.dispensedBy">
							<div class="subtitle">DISPENSADO POR</div>
							<p>
								{{ item.dispensedBy.name }}
							</p>
						</div> -->
					</div>
				</div>

				<div class="col-md-4">
					<div class="medic-info">
						<div class="subtitle">PACIENTE</div>
						<h1>{{ item.patient.name }}</h1>
						<p>{{ item.patient.documentText }}</p>
					</div>

					<hr />
					<div class="medic-info">
						<div class="subtitle">MEDICO</div>
						<h1>{{ item.medic.name }}</h1>
						<p>{{ item.medic.documentText }}</p>
					</div>
				</div>

				<div class="col-12">
					<div class="actions-box">
						<div class="buttons mt-3">
							<!-- <button class="btn btn-danger pull-right" v-if="item.canCancel" @click="cancelDispensation()">
								CANCELAR DISPENSACIÓN
							</button> -->
							<router-link tag="button" class="btn btn-sm pull-left" to="/dispensations">Volver</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "PrescriptionDetail",

	data() {
		return {
			loading: true,
			item: {}
		}
	},
	beforeMount() {
		console.log(this.$route)
		this.load()
	},

	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							prescription(id: $id) {
								code
								product {
									id
									name
									presentation
								}
								dosage
								medicalHistory
								affections
								indications
								dispensation {
									id
									createdAt
								}
								patient {
									id
									name
									lastname
									documentText
								}
								medic {
									id
									name
									lastname
									documentText
								}
								createdAt
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.$route.params.id
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.item = data.prescription
					this.loading = false
				})
		}

		// cancelDispensation() {
		// 	if (!this.saving) {
		// 		this.saving = true
		// 		this.$apollo
		// 			.mutate({
		// 				mutation: gql`
		// 					mutation($id: ID!) {
		// 						dispensationCancel(id: $id) {
		// 							id
		// 						}
		// 					}
		// 				`,
		// 				variables: {
		// 					id: this.item.id
		// 				}
		// 			})
		// 			.then(() => {
		// 				this.$toast.success("Dispensación cancelada correctamente")
		// 				this.saving = false
		// 				this.load()
		// 			})
		// 			.catch(error => {
		// 				this.parseGQLErrors(error)
		// 				this.saving = false
		// 			})
		// 	}
		// }
	}
}
</script>

<style scoped>
.book-data {
	width: 100%;
}
.book-data .box {
	padding: 12px 8px;
}
.book-data .box:not(:last-child) {
	border-bottom: solid 1px #ededed;
}
.subtitle {
	font-size: 12px;
	text-transform: uppercase;
	color: #666;
}
.book-data .box .value {
	font-size: 18px;
	line-height: 18px;
}
.book-data .box .value p {
	font-size: 14px;
	text-transform: none;
	line-height: 14px;
}

.medic-info {
	border-left: solid 1px #ededed;
	padding: 18px;
	text-align: center;
}
.medic-info figure {
	margin: auto;
	border-radius: 45px;
	overflow: hidden;
}

.medic-info .rating {
	margin-bottom: 20px;
	display: inline-block;
}

.medic-info small {
	text-transform: uppercase;
	color: #999;
	font-weight: 600;
}

.medic-info h1 {
	font-size: 18px;
}

.actions-box {
	border-top: 1px solid #ededed;
	width: 100%;
	padding: 12px 8px;
}
</style>
